import DOMPurify from "dompurify";

const escapeHtml = (value: string) =>
	value
		.replaceAll("&", "&amp;")
		.replaceAll("<", "&lt;")
		.replaceAll(">", "&gt;")
		.replaceAll('"', "&quot;")
		.replaceAll("'", "&#39;");

export const sanitizeHtml = (content?: unknown) => {
	const value = content == null ? "" : String(content);

	if (typeof window === "undefined") {
		return escapeHtml(value);
	}

	return DOMPurify.sanitize(value);
};
